import type { CMSComponent } from '@/components/cms/schemas';
import { CMSComponentSchema } from '@/components/cms/schemas';
import { z } from 'zod';
import { CMSSEOSchema } from '../common';

export const CMSPageSchema = z
  .object({
    title: z.string(),
    content: z.array(CMSComponentSchema).nonempty(),
  })
  .merge(CMSSEOSchema);

export interface CMSPage {
  title: string;
  content: CMSComponent[];
  seo_page_title?: string;
  seo_description?: string;
  seo_keywords?: string;
}
